import { gql } from "lib/apolloClient";

export const userFragment = {
  userDetailItem: gql`
    fragment userDetailItem on User {
      id
      firstName
      lastName
      type
      profileImage

      ... on Student {
        isArchived
        isDeleted
        middleName
        yearGroup {
          id
          grade {
            id
            name
          }
        }
      }

      ... on Staff {
        isArchived
        isDeleted
        displayRole
        role
      }

      ... on FamilyMember {
        children(organizationId: $organizationId) {
          id
          firstName
          lastName
          middleName
        }
      }
    }
  `,
};
